import React from "react";
import { IMAGES, buildWhatsAppLink } from "../constants";

export default function BrandStory() {
  return (
    <section
      id="historia"
      data-testid="brand-story-section"
      className="relative py-24 sm:py-32 bg-cream overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-6 relative">
          <div className="img-zoom rounded-[2rem] overflow-hidden aspect-[4/5] shadow-[0_50px_120px_-40px_rgba(44,36,36,0.4)]">
            <img
              src="brand/familia.jpg"
              alt="Naiderly Marquez con sus hijas"
              className="w-full h-full object-cover"
              data-testid="brand-story-image"
            />
          </div>
          <div className="absolute bottom-6 -left-4 sm:-left-8 paper-card rounded-2xl px-6 py-5 max-w-[260px]">
            <div className="label-eyebrow mb-1">Fundadora</div>
            <div className="font-heading text-xl text-ink leading-tight">
              Naiderly Marquez
            </div>
            <div className="text-xs text-[#5C5050] mt-1">
              Madre de tres niñas · Valencia, Venezuela
            </div>
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="label-eyebrow mb-4">Nuestra historia</div>
          <h2
            data-testid="brand-story-title"
            className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink leading-[1.05]"
          >
            Hecho por <span className="italic text-[#722F37]">madres</span>,
            pensado para <span className="italic">familias</span>.
          </h2>

          <div className="mt-7 space-y-5 text-[15px] sm:text-base text-ink-soft leading-relaxed max-w-xl">
            <p>
              Vallitas nace de una promesa. De una madre venezolana que decidió
              transformar su fe en oficio, y su oficio en familia. Inspirada en
              la <strong className="text-vino font-medium">Virgen del Valle</strong>,
              Naiderly Marquez cosió las primeras prendas mientras cuidaba a sus
              tres niñas.
            </p>
            <p>
              Hoy, cada body, cada jersey y cada conjunto que sale del taller
              lleva con él la misma intención de los inicios: que quien lo viste
              se sienta acompañado, valiente y orgulloso de sus raíces.
            </p>
            <p className="font-heading italic text-2xl text-vino leading-snug">
              “Cada prenda es una bendición que se queda contigo.”
            </p>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-4 max-w-md">
            {[
              { label: "Fe", v: "✦" },
              { label: "Familia", v: "✦" },
              { label: "Esfuerzo", v: "✦" },
            ].map((it) => (
              <div
                key={it.label}
                data-testid={`brand-value-${it.label.toLowerCase()}`}
                className="paper-card rounded-2xl py-5 px-3 text-center"
              >
                <div className="text-vino text-2xl mb-2">{it.v}</div>
                <div className="text-xs uppercase tracking-[0.2em] text-ink">
                  {it.label}
                </div>
              </div>
            ))}
          </div>

          <a
            href={buildWhatsAppLink("Hola Naiderly, quiero conocer más sobre Vallitas.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="brand-story-cta"
            className="mt-10 inline-flex items-center gap-2 text-vino font-medium link-underline"
          >
            Habla con la fundadora →
          </a>
        </div>
      </div>
    </section>
  );
}
